export const PULL_THRESHOLD = 64;

export const PULL_MAX = 96;

export const PULL_DAMPING = 0.5;
